import { useState, useEffect } from 'react';

import { CatalogStarlinkType, PrismicCatalog } from 'domains/catalog';
import { StarlinkResponse } from 'domains/starlink';
import { getCycleId } from 'helpers';
import { CardCatalogProps } from 'pages/Catalogs/components';
import { useGlobalContext } from 'store';

import { useStarlinkContent } from './useStarlinkContent';

export const useNextCatalogs = () => {
  const {
    data: starlinkData,
    isLoading: isLoadingStarlinkContent,
    isSuccess: isSuccessStarlinkContent,
  } = useStarlinkContent<CatalogStarlinkType>({
    document: 'collection_catalogs',
  });

  const [nextCycleItems, setNextCycleItems] = useState<CardCatalogProps[]>([]);

  const [starlinkContent, setStarlinkContent] =
    useState<StarlinkResponse<unknown, PrismicCatalog[]>>();

  const { user } = useGlobalContext();
  useEffect(() => {
    if (isSuccessStarlinkContent && starlinkData) {
      setStarlinkContent({ ...starlinkData?.items[0] });
    }
  }, [isSuccessStarlinkContent, starlinkData]);

  useEffect(() => {
    if (
      !isLoadingStarlinkContent &&
      starlinkContent?.data?.catalogs?.length &&
      starlinkContent?.data?.catalogs?.length > 0
    ) {
      if (starlinkContent) {
        setNextCycleItems([
          ...starlinkContent?.data.catalogs
            .filter(
              (catalog) =>
                getCycleId({ cycleYear: catalog.cycleYear, cycleNumber: catalog.cycleNumber }) >
                user?.cycle?.currentCycle
            )
            .map((catalog) => {
              const catalogLink = catalog.link?.url
                ? catalog?.link?.url.replace(
                    /\/(revendedor|representante)\//,
                    `/redirect/${user?.resellerId}?to=/`
                  )
                : '';
              return {
                cycleStart: catalog.cycleStart ?? '',
                cycleEnd: catalog.cycleEnd ?? '',
                banner: catalog.banner?.url ?? '',
                link: catalogLink,
                brand: catalog.brand ?? '',
                cycleNumber: catalog.cycleNumber ?? 0,
                cycleYear: catalog.cycleYear ?? 0,
              };
            }),
        ]);
      }
    }
  }, [isLoadingStarlinkContent, starlinkContent, user.cycle.currentCycle, user.resellerId]);
  return {
    isLoading: isLoadingStarlinkContent,
    isSuccess: isSuccessStarlinkContent,
    starlinkData,
    data: nextCycleItems,
  };
};
